import { initReactI18next } from 'react-i18next'
import de from 'assets/i18n/de.json'
import en from 'assets/i18n/en.json'
import fr from 'assets/i18n/fr.json'
import i18n from 'i18next'

i18n.use(initReactI18next).init({
  resources: {
    en,
    fr,
    de,
  },
  defaultNS: 'common',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})
